import { useEffect, useRef, useState } from 'react';

import Icon from '../icon/Icon';

import './Select.scss';

/**
 * Тот же визуал, что у {@link Select}, но без redux-form — value/onChange.
 */
export function SelectPlain({
  id = 'select-plain',
  value,
  onChange,
  options = [],
  disabled = false,
  readOnly = false,
  ghost = false,
  size = 'default',
  className = '',
  placeholder = 'Выберите из списка',
  'aria-label': ariaLabel,
}) {
  const list = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(null);

  const handleOpen = (e) => {
    e.preventDefault();
    if (disabled || readOnly) return;
    setOpen((o) => !o);
  };

  const handleClickOutside = (e) => {
    if (list.current?.contains(e.target)) return;
    setOpen(false);
  };

  const handleOnMouseDown = (e) => {
    e.preventDefault();
  };

  const getCurrentTitle = (opts) => {
    if (value == null || value === '' || !opts?.length) return null;
    const found = opts.find((i) => String(i.value) === String(value));
    return found?.title ?? null;
  };

  useEffect(() => {
    setCurrentTitle(getCurrentTitle(options));
  }, [options, value]);

  useEffect(() => {
    if (!isOpen) return undefined;
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  const handleOnChange = (e) => {
    const next = e.currentTarget.dataset.value;
    const opt = options.find((o) => String(o.value) === String(next));
    setCurrentTitle(opt?.title ?? null);
    if (typeof onChange === 'function') {
      onChange(next);
    }
    setOpen(false);
  };

  return (
    <div
      ref={list}
      className={`nlk-select ${size ? `nlk-select_${size}` : ''} ${ghost ? 'ghost' : ''} ${className}`.trim()}
    >
      <div className="nlk-select__input">
        <button
          type="button"
          className="nlk-select__input__button"
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          aria-controls={`${id}-listbox`}
          aria-label={ariaLabel}
          onMouseDown={handleOnMouseDown}
          onClick={handleOpen}
          id={id}
          disabled={disabled}
        >
          {currentTitle ? currentTitle : <span>{placeholder}</span>}
        </button>

        {isOpen && options?.length > 0 && !readOnly ? (
          <ul
            id={`${id}-listbox`}
            tabIndex={-1}
            role="listbox"
            className="nlk-select__input__list"
          >
            {options.map(({ value: optValue, title }) => (
              <li
                role="option"
                key={String(optValue)}
                className="nlk-select__input__list__option"
                onClick={handleOnChange}
                onMouseDown={handleOnMouseDown}
                data-value={optValue}
              >
                {title}
                {title === currentTitle && String(optValue) === String(value) ? (
                  <div>
                    <Icon
                      icon="Checkbox/Check"
                      className="nlk-select__input__list__option__icon"
                      color="currentColor"
                      height={6.85}
                      width={8.6}
                    />
                  </div>
                ) : null}
              </li>
            ))}
          </ul>
        ) : null}
        <div>
          {!ghost ? (
            <Icon
              icon="Select/Arrow"
              className="nlk-select__input__icon"
              color="currentColor"
              height={12}
              width={5.3}
            />
          ) : (
            <Icon
              icon="Arrow/Down"
              className="nlk-select__input__icon"
              color="#fff"
              height={6.85}
              width={8.6}
            />
          )}
        </div>
      </div>
    </div>
  );
}
